import React from "react";
import { render } from "react-dom";
import { App } from "smarthub-core";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { initializeFileTypeIcons } from "@fluentui/react-file-type-icons";
import { ISmartHubAPI, Logger } from "smarthub-common";
import { config } from "config";

export const createSmartHub = (selector: string): Promise<ISmartHubAPI> =>
  new Promise((resolve, reject) => {
    try {
      const appConfig = config();
      const container = document.querySelector(selector);
      const onAPIReady = (api: ISmartHubAPI) => resolve(api);

      initializeIcons();
      initializeFileTypeIcons();

      render(<App {...appConfig} onAPIReady={onAPIReady} />, container);
    } catch (ex) {
      Logger.error("Failed to load app", false, ex);
      reject(new Error("Failed to load SmartHub"));
    }
  });
